import React from "react";

const UserFooter = () => {
  return (
    <>
      <div className="user-footer">
        <div className="container">
          <ul className="list-unstyled">
            <li>
              <a href="https://www.oneheartcleaning.com.sg/terms" target="blank" style={{cursor:"pointer"}}>Terms and Conditions</a>
            </li>
            <li>
              <a href="https://www.oneheartcleaning.com.sg/privacy" target="blank" style={{cursor:"pointer"}}>Privacy Policy</a>
            </li>
            <li>
              <a href="https://www.oneheartcleaning.com.sg/support" target="blank" style={{cursor:"pointer"}}>Support</a>
            </li>
            <li>
              <a href="https://www.oneheartcleaning.com.sg/feedback" target="blank" style={{cursor:"pointer"}}>Feedback</a>
            </li>
          </ul>
          <p className="mb-0">
            Copyright One Heart Cleaning Pte Ltd. All Right Reserved
          </p>
        </div>
      </div>
    </>
  );
};

export default UserFooter;
